export const state = {
  products: [],
  systemProduct: [],
  singleproducts: [],
  deadproducts: [],
  prod_no: [],
  sellprice: [],
  statproductsales: [],
  total: [],
  topPurchasedProducts: [],
  topSoldProducts: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/state.js